import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

export const useMsrAaTest = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	/**
	 * Used to gauge the amount of requests we'll be sending to GRS
	 */
	const fireMsrAaFetchTrackEvent = () => {
		fireTrackAnalytics(createAnalyticsEvent({}), 'cjnMsrRecommendations fetched');
	};

	/**
	 * Used to detect possible cohort pollution between different experiments
	 */
	const fireMsrAaExposureTrackEvent = (aaExperiment: string, cohort?: string) => {
		fireTrackAnalytics(createAnalyticsEvent({}), 'feature exposed', {
			cohort,
			flagKey: 'aa_for_twcg-437-cjn-msr-m1',
			aaExperiment,
		});
	};

	return {
		fireMsrAaExposureTrackEvent,
		fireMsrAaFetchTrackEvent,
	};
};
